import Avatar from 'common/Avatar/Avatar'
import Styles from './RecipientAvatars.module.scss'
import { getInitials } from 'utils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { Text } from 'blaze-ui/Text/Text'

export type UserAvatar = {
  avatar_url: string
  display_name: string
}

interface Props {
  users: UserAvatar[]
  size?: number
  maxUsers?: number
}

export const RecipientAvatars = ({
  users,
  size = 44,
  maxUsers = 10,
}: Props) => {
  const workspaceId = useCurrentWorkspaceId()

  return (
    <div className={Styles.recipients}>
      {users.slice(0, maxUsers).map((user, i) => (
        <div key={`recipient-${i}`} style={{ zIndex: users.length - i }} className={Styles.avatarContainer}>
          <Avatar
            url={user.avatar_url}
            workspaceId={workspaceId}
            borderColor="var(--neutral-0)"
            label={getInitials(user.display_name)}
            size={size}
          />
        </div>
      ))}

      {users?.length > maxUsers && (
        <div className={Styles.moreAvatarContainer} style={{ width: size, height: size }}>
          <Text variant="secondary">+{users.length - maxUsers}</Text>
        </div>
      )}
    </div>
  )
}
